<button
    class="cmps-icon-button--no-bg"
    cmpsIconButton
    [cmpsTooltipTrigger]="
        (completed === true
            ? _i18n._11244_UNMARK_TASK_AS_COMPLETED
            : _i18n._11245_MARK_TASK_AS_COMPLETED
        ) | translate
    "
    (click)="$event.stopPropagation(); click.emit()"
>
    <cmps-icon
        class="cmps-cdk-fill-blue-100"
        [svgIcon]="
            completed === true || _task?._mouseoverTask === true
                ? 'checkbox-marked-circle-auto-outline'
                : 'circle-outline'
        "
    ></cmps-icon>
</button>
